exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "section.content{min-height:calc(100vh - 130px);overflow:auto}div.audioRecorder{display:inline}div.audioRecorder>div{display:inline}#audioRecorder-fwrecorder{display:none}.fa-beat{animation:fa-beat 5s ease infinite}@keyframes fa-beat{0%{transform:scale(1)}5%{transform:scale(1.25)}20%{transform:scale(1)}30%{transform:scale(1)}35%{transform:scale(1.25)}50%{transform:scale(1)}55%{transform:scale(1.25)}70%{transform:scale(1)}}.k-maskedtextbox.form-control,.k-maskedtextbox.form-control:hover{padding:0px !important;border:none !important}", ""]);

// exports
